import { render, staticRenderFns } from "./BookingRateConfirm.vue?vue&type=template&id=17bf5eac&"
import script from "./BookingRateConfirm.vue?vue&type=script&lang=js&"
export * from "./BookingRateConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports